import { Box, Switch, Tooltip, Typography } from "@mui/material";
import type { JSX } from "react";

/**
 * The "Auto-generate" switch in the pending-approval header — lets the operator
 * stop the agent flooding the timeline right where they see it happening.
 * Disabled (and forced on) under fully-autonomous mode. Extracted from
 * `PendingApprovalTable.tsx`; only mounted for `marketing:manage` viewers with
 * loaded settings.
 */
export function AutoGenerateToggle({
  fullyAuto,
  autoOn,
  pending,
  onToggle,
}: {
  fullyAuto: boolean;
  autoOn: boolean;
  pending: boolean;
  onToggle: (next: boolean) => void;
}): JSX.Element {
  return (
    <Tooltip
      title={
        fullyAuto
          ? "Fully-autonomous mode is on — drafting follows it"
          : autoOn
            ? "The agent is auto-generating drafts from trends. Turn off to stop."
            : "Off — the agent only suggests ideas; you generate. Turn on to let it auto-draft."
      }
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
        <Typography sx={{ fontSize: 12, color: "text.secondary", whiteSpace: "nowrap" }}>
          Auto-generate
        </Typography>
        <Switch
          size="small"
          checked={autoOn}
          disabled={fullyAuto || pending}
          onChange={(_, checked) => onToggle(checked)}
          inputProps={{ "aria-label": "Auto-generate drafts" }}
        />
      </Box>
    </Tooltip>
  );
}
